// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"82909c8e","32":"b3263246"}[chunkId] + ".chunk.css";
};